import React, { lazy } from "react";
import { defer } from "react-router-dom";
import RouteLoader from "../UI/RouteLoader";
import { getSeminarRequest } from "../../requests/seminars";
import { withSuspense } from "./routeHelpers";

const Seminars = lazy(
  () => import(/* webpackChunkName: "seminars" */ "../Seminars/Seminars")
);
const Seminar = lazy(
  () => import(/* webpackChunkName: "seminars" */ "../Seminars/Seminar/Seminar")
);
const SeminarDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "seminars" */ "../Seminars/Seminar/SeminarDetails/SeminarDetails"
    )
);
const SeminarStudents = lazy(
  () =>
    import(
      /* webpackChunkName: "seminars" */ "../Seminars/Seminar/SeminarStudents/SeminarStudents"
    )
);
const SeminarPresentations = lazy(
  () =>
    import(
      /* webpackChunkName: "seminars" */ "../Seminars/Seminar/SeminarPresentations/SeminarPresentations"
    )
);
const SeminarAttendance = lazy(
  () =>
    import(
      /* webpackChunkName: "seminars" */ "../Seminars/Seminar/SeminarAttendance/SeminarAttendance"
    )
);
const SeminarDecisions = lazy(
  () =>
    import(
      /* webpackChunkName: "seminars" */ "../Seminars/Seminar/SeminarDecisions/SeminarDecisions"
    )
);
const SeminarProducts = lazy(
  () =>
    import(
      /* webpackChunkName: "seminars" */ "../Seminars/Seminar/SeminarProducts/SeminarProducts"
    )
);
const SeminarNew = lazy(
  () =>
    import(/* webpackChunkName: "seminars" */ "../Seminars/Seminar/SeminarNew")
);
const SeminarPrintTickets = lazy(
  () =>
    import(
      /* webpackChunkName: "seminars" */ "../Seminars/Seminar/SeminarPrintTickets/SeminarPrintTickets"
    )
);

export default [
  {
    path: "/seminars",
    element: withSuspense(Seminars),
  },
  {
    path: "/seminars/new",
    element: withSuspense(SeminarNew),
  },
  {
    path: "/seminars/:seminarId",
    element: (
      <RouteLoader>
        {(loader) => withSuspense(<Seminar seminar={loader?.data} />)}
      </RouteLoader>
    ),
    id: "seminar",
    loader: ({ params }) => {
      return defer({
        data: getSeminarRequest({ seminarId: params.seminarId }),
      });
    },
    children: [
      {
        path: "/seminars/:seminarId/details",
        element: withSuspense(SeminarDetails),
      },
      {
        path: "/seminars/:seminarId/students",
        element: withSuspense(SeminarStudents),
      },
      {
        path: "/seminars/:seminarId/presentations",
        element: withSuspense(SeminarPresentations),
      },
      {
        path: "/seminars/:seminarId/attendance",
        element: withSuspense(SeminarAttendance),
      },
      {
        path: "/seminars/:seminarId/decisions",
        element: withSuspense(SeminarDecisions),
      },
      {
        path: "/seminars/:seminarId/products",
        element: withSuspense(SeminarProducts),
      },
      {
        path: "/seminars/:seminarId/print-tickets",
        element: withSuspense(SeminarPrintTickets),
      },
    ],
  },
];
